import React, { useMemo } from 'react'
import { Delete , Edit } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";

import { useStyles } from "./styles";
import { StyleSwitch } from '../../../yoello-lib/modules/dynamicForms/FormComponents/FormSwitch';

interface IVenueAreaToolbar {
  onEdit : () => void;
  onDelete : () =>void;
  onStatusChangeHandler: (enabled:boolean) =>void;
  name_public : string;
  enabled:boolean;
}

function VenueAreaToolbar({ name_public, enabled, onEdit, onDelete, onStatusChangeHandler }:IVenueAreaToolbar) {

  const classes = useStyles();

  const FormSwitch = useMemo(() => <StyleSwitch  onClick={(e) => e.stopPropagation()}   defaultChecked={enabled} onChange={(e:React.ChangeEvent<HTMLInputElement>,value: any) => {
    e.stopPropagation();
    onStatusChangeHandler(value);
  }}  color="primary" /> 
  // eslint-disable-next-line
  ,[enabled])
  return (
    <div 
      className={classes.wrapper}
      data-component-name = {name_public}
    >
      <p>
        {name_public}
      </p>
      <div>
        {FormSwitch}
        <IconButton onClick={(e:React.MouseEvent<HTMLElement>) => {
         e.stopPropagation(); 
         onEdit();
        }} aria-label="edit-area" data-component-name={`group-${name_public}-edit-btn`}>
                        <Edit style={{color:"#AAB6D3"}} />
          </IconButton>
        <IconButton onClick={(e:React.MouseEvent<HTMLElement>) => {
         e.stopPropagation(); 
         onDelete();
        }} aria-label="delete-area" data-component-name={`group-${name_public}-delete-btn`}>
                        <Delete style={{color:"#AAB6D3"}} />
          </IconButton>
      </div>
    </div>
  )
}

export default VenueAreaToolbar;
